import {Action, State, StateContext} from '@ngxs/store';
import {Injectable} from '@angular/core';
import {tap} from 'rxjs/operators';
import {
  LoadCountries,
  LoadUniversities,
  LoadUniversityFields,
  LoadDatabase,
  LoadRankFields,
  LoadVisualizations,
  LoadFiltered, GetUniversityFieldMinMax, CheckFilters, ShowTutorial,
} from './core.actions';
import {CoreService} from '../services/core.service';
import {Database} from "../models";

export interface FiltersCheckResult {
  checked: boolean;
  total: number;
  text: string;
}

export class DashboardStateModel {
  public database: Database;
  public countries: any[];
  public universities: any[];
  public universityFields: any[];
  public rankFields: any[];
  public filteredUniversities: any[];
  public visualizations: any[];
  public checkFiltersResult: FiltersCheckResult;
  public showTutorial: boolean;
}

@State<DashboardStateModel>({
  name: 'core',
  defaults: {
    database: new Database(0, '', '', 0),
    countries: [],
    universities: [],
    universityFields: [],
    rankFields: [],
    filteredUniversities: [],
    visualizations: [],
    checkFiltersResult: {checked: false, total: 0, text: ''},
    showTutorial: false,
  }
})
@Injectable()
export class CoreState {

  @Action(LoadDatabase)
  loadDatabase(ctx: StateContext<DashboardStateModel>, action: LoadDatabase) {
    const state = ctx.getState();

    return this.coreService.fetchDatabase().pipe(
      tap((response: any) => {
        ctx.patchState({database: response[0]});
      })
    );
  }

  @Action(LoadCountries)
  loadCountries(ctx: StateContext<DashboardStateModel>, action: LoadCountries) {
    const state = ctx.getState();

    return this.coreService.fetchCountries().pipe(
      tap((response: any) => {
        ctx.patchState({countries: response});
      })
    );
  }

  @Action(LoadUniversities)
  LoadUniversities(ctx: StateContext<DashboardStateModel>, action: LoadUniversities) {
    const state = ctx.getState();

    return this.coreService.fetchUnivesities().pipe(
      tap((response: any) => {
        ctx.patchState({universities: response});
      })
    );
  }

  @Action(LoadUniversityFields)
  loadUniversityFields(ctx: StateContext<DashboardStateModel>, action: LoadUniversityFields) {
    const state = ctx.getState();

    return this.coreService.fetchUniversityFields().pipe(
      tap((response: any) => {
        ctx.patchState({universityFields: response});
      })
    );
  }

  // @Action(GetUniversityFieldMinMax)
  // GetUniversityFieldMinMax(ctx: StateContext<DashboardStateModel>, action: GetUniversityFieldMinMax) {
  //   const state = ctx.getState();
  //
  //   return this.coreService.getUniversityFieldsMinMax(action.field).pipe(
  //     tap((response: any) => {
  //       ctx.patchState({universityFields: response});
  //     })
  //   );
  // }

  @Action(LoadRankFields)
  loadRankFields(ctx: StateContext<DashboardStateModel>, action: LoadRankFields) {
    const state = ctx.getState();

    return this.coreService.fetchRankFields().pipe(
      tap((response: any) => {
        ctx.patchState({rankFields: response});
      })
    );
  }

  @Action(LoadVisualizations)
  loadVisualizations(ctx: StateContext<DashboardStateModel>, action: LoadVisualizations) {
    const state = ctx.getState();

    return this.coreService.fetchVisualizations().pipe(
      tap((response: any) => {
        let visualizations = response.map(v => v['conf']);
        ctx.patchState({visualizations: visualizations});
      })
    );
  }

  @Action(LoadFiltered)
  loadFiltered(ctx: StateContext<DashboardStateModel>, action: LoadFiltered) {

    return this.coreService.loadFiltered(action.payload).pipe(
      tap((response: any) => {

        ctx.patchState({
          filteredUniversities: response
        });
      })
    );
  }

  @Action(CheckFilters)
  checkFilters(ctx: StateContext<DashboardStateModel>, action: CheckFilters) {
    const state = ctx.getState();

    return this.coreService.checkFilters(action.filters).pipe(
      tap((response: any) => {
        ctx.patchState({checkFiltersResult: response});
      })
    );
  }

  @Action(ShowTutorial)
  showTutorial(ctx: StateContext<DashboardStateModel>, action: ShowTutorial) {
      ctx.patchState({showTutorial: action.show});
  }


  constructor(private coreService: CoreService) {
  }

}

